// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm1-8.414V5a1 1 0 0 0-2 0v5c0 .266.105.52.293.707l3 3a.994.994 0 0 0 1.414 0 .997.997 0 0 0 0-1.414L11 9.586z\"/></svg> ";
// Exports
module.exports = code;